export const HEX_COLOR_PALETTE = ['#2d7dff', '#1f9d55', '#ffb020', '#a855f7', '#ff4568', '#00e5ff', '#00e676', '#06b6d4', '#f97316'];
